/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PrivacyPolicyShowPathParams, PrivacyPolicyShowResponse } from '../types/PrivacyPolicyShow'

/**
 * GET /organisations/:organisation/privacy-policy
 * @see backend/nexus/modules/Organisation/Http/Controllers/PrivacyPolicyController.php PrivacyPolicyController::show
 */
export async function privacyPolicyShow(
	organisation: PrivacyPolicyShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PrivacyPolicyShowResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/privacy-policy`, config)
}
